import { useState, useEffect, useCallback } from "react";
import { getUploadedFileInfo, downloadFile } from "../services/serviceRequestService";

/**
 * Custom hook for handling file uploads and downloads
 * @param {string} queryId - Query ID
 * @param {string} accessToken - Salesforce access token
 * @returns {Object} File state and handlers
 */
export const useFileHandler = (queryId, accessToken) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!queryId) return;

    const fetchFiles = async () => {
      setLoading(true);
      setError(null);
      
      const response = await getUploadedFileInfo(queryId);
      
      if (response.success) {
        setUploadedFiles(response.data);
      } else {
        setError(response.error);
      }
      
      setLoading(false);
    };

    fetchFiles();
  }, [queryId]);

  const handleDownload = useCallback(async (versionId, fileName) => {
    if (!accessToken) {
      setError("Access token not available");
      return;
    }

    try {
      const blob = await downloadFile(versionId, accessToken);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      setError("Failed to download file");
    }
  }, [accessToken]);

  return {
    uploadedFiles,
    loading,
    error,
    handleDownload,
  };
};
